import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { ShareAction, CopyLinkAction, AddPeopleAction } from '../../actions/share/ShareAction';
import CommandStrings from '../Commands.resx';
import KeyboardMapStrings from '../../keyboard/KeyboardMap.resx';
import { isShareFacet } from '../../../facets/CommandFacets';

export const shareCommand: ICommand = {
  key: new Facet('share').id,
  automationId: 'shareCommand',
  name: CommandStrings.Share,
  title: CommandStrings.ShareCommandTooltipV3,
  action: <ShareAction />,
  iconProps: {
    iconName: 'Share'
  },
  keytipProps: {
    keySequences: ['S'],
    content: KeyboardMapStrings.showShareDesc
  },
  facets: {
    ...isShareFacet.pack(true)
  }
};

export const copyLinkCommand: ICommand = {
  key: new Facet('copyLink').id,
  automationId: 'copyLinkCommand',
  name: CommandStrings.CopyLinkCommandText,
  title: CommandStrings.CopyLinkCommandTooltipV3,
  action: <CopyLinkAction />,
  iconProps: {
    iconName: 'Link'
  },
  facets: {
    ...isShareFacet.pack(true)
  }
};

export const addPeopleCommand: ICommand = {
  key: new Facet('addPeople').id,
  automationId: 'addPeopleCommand',
  name: CommandStrings.GrantAccess,
  title: CommandStrings.GrantAccessCommandLabel,
  action: <AddPeopleAction />,
  iconProps: {
    iconName: 'PlayerSettings'
  },
  facets: {
    ...isShareFacet.pack(true)
  }
};
